import { createRef, useCallback, useEffect, useState } from "react";

import Image from "next/image";
import { useRouter } from "next/router";

import useTranslation from "next-translate/useTranslation";
import PropTypes from "prop-types";
import { useReactToPrint } from "react-to-print";

import badgeCertificate from "shared/assets/icons/badge-certificate.svg";
import Widget from "shared/components/templates/Widget";
import api from "shared/infra/services/api";

import Certificate from "../index";
import {
  ButtonAnt,
  ContainerCertificate,
  ContentInfo,
  RenderCertificateContainer,
} from "./styles";

export default function RenderCertificate({
  hasEnrollment,
  allowCertificate,
  certificateEnabled,
  course,
}) {
  const componentRef = createRef<any>();
  const router = useRouter();
  const { t } = useTranslation();
  const locale = router.locale;
  const slug_course = router.query?.course_slug;

  const isVisibleActionButton =
    allowCertificate && certificateEnabled && hasEnrollment;

  const [certificateData, setCertificateData] = useState(null);

  const handlePrint = useReactToPrint({
    content: () => componentRef?.current,
    documentTitle: `${"conclusionCertificate"})}
    ${certificateData?.attrs?.course_title}`,
  });

  const onGenerateCertificate = useCallback(async () => {
    try {
      const response = await api.post(`create/certificate/${slug_course}`);

      setCertificateData(response.data);
    } catch (error) {
      console.log(error);
    }
  }, [slug_course]);

  useEffect(() => {
    if (certificateData?.attrs) handlePrint();
  }, [certificateData?.attrs]);

  return (
    <RenderCertificateContainer>
      <Widget
        transparentDarkDisabled
        styleName="widget-margin-top gx-card-tabs gx-card-tabs-right gx-card-profile"
        title={t("common:certificate")}
      >
        <ContentInfo>
          <div className="image-container-render-certificate">
            <Image alt="certificate" src={badgeCertificate} fill />
          </div>
          {isVisibleActionButton ? (
            <p>
              {t("common:youHit")}
              {`${course?.minimum_percentage}%`}
              {t("common:courseCompleted")}
            </p>
          ) : (
            <p>
              {t("common:courseOffersACertificate")}
              {`${course?.minimum_percentage}%`}
              {t("common:ofCourse")}
            </p>
          )}
        </ContentInfo>

        {isVisibleActionButton && (
          <ButtonAnt block type="primary" onClick={onGenerateCertificate}>
            {t("common:getCertificate")}
          </ButtonAnt>
        )}

        <ContainerCertificate>
          <Certificate
            ref={componentRef}
            data={certificateData}
            intl={t}
            locale={locale}
          />
        </ContainerCertificate>
      </Widget>
    </RenderCertificateContainer>
  );
}

RenderCertificate.defaultProps = {
  hasEnrollment: false,
  allowCertificate: false,
  certificateEnabled: false,
  course: null,
};

RenderCertificate.propTypes = {
  hasEnrollment: PropTypes.bool,
  allowCertificate: PropTypes.bool,
  certificateEnabled: PropTypes.bool,
  course: PropTypes.object,
};
